import { useEffect, useRef } from 'react'
import { LoaderFunctionArgs, useLoaderData } from 'react-router-dom'
import { PaymentDetail, fetchPayment } from '../../api/payments'
import { trackEvent } from '../../lib/config'
import { hcCurrency } from '../../lib/currency'
import { ButtonAnchor, PageHeading, Panel } from '../../components/common'

declare global {
  interface Window {
    gtag?: (command: string, event: string, params: Record<string, unknown>) => void
  }
}

function DetailRow({ label, value, first }: { label: string; value: string; first?: boolean }) {
  return (
    <tr>
      <td style={{ width: '40%', ...(first ? { borderTop: 0 } : {}) }}>{label}</td>
      <td style={{ textAlign: 'right', ...(first ? { borderTop: 0 } : {}) }}>{value}</td>
    </tr>
  )
}

export function loader({ params, request }: LoaderFunctionArgs): Promise<PaymentDetail> {
  const gwp = new URL(request.url).searchParams.get('gwp') === 'true'
  return fetchPayment(Number(params.healthCenterId), params.paymentId as string, gwp)
}

export default function PaymentShowPage() {
  const data = useLoaderData() as Awaited<ReturnType<typeof loader>>
  const hasTracked = useRef(false)

  // This screen is already the app's agreed purchase marker, so the Mixpanel
  // event sits beside the gtag conversion rather than inventing a second one.
  // The charge itself is booked server-side by track_payment_received.
  useEffect(() => {
    if (hasTracked.current) {
      return
    }
    hasTracked.current = true
    trackEvent('Purchase Completed', {
      amount: data.payment.amount,
      plan: data.payment.description,
      order_id: data.payment.order_id,
      first_payment: data.first_payment,
    })
    if (data.first_payment) {
      window.gtag?.('event', 'conversion', {
        send_to: 'AW-851627562/TzB_CPqmhZUBEKqci5YD',
        value: data.payment.amount,
        currency: 'CLP',
        transaction_id: data.payment.order_id,
      })
    }
  }, [data])

  return (
    <div className="row" style={{ paddingTop: 10 }}>
      <div className="col-md-8 col-md-offset-2 col-xs-12">
        <Panel style={{ marginTop: 10 }}>
          <div className="well" style={{ border: 'none', boxShadow: '0 0px' }}>
            <div className="row">
              <PageHeading>{`Orden ${data.payment.order_id}`}</PageHeading>
            </div>
            <div className="row">
              <div className="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
                <div className="tab-pane active">
                  <table className="table table-responsive">
                    <tbody>
                      <DetailRow first label="Monto" value={hcCurrency(data.payment.amount)} />
                      <DetailRow label="Descripción" value={data.payment.description ?? ''} />
                      <DetailRow label="Fecha de pago" value={data.payment.paid_at} />
                      <DetailRow label="Estado" value={data.payment.state} />
                      <DetailRow label="Forma de pago" value="Webpay" />
                      <DetailRow label="Periodo de pago" value={`${data.payment.begin_date} - ${data.payment.end_date}`} />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="row" style={{ textAlign: 'center' }}>
              <ButtonAnchor href={data.payments_path}>Ir historial</ButtonAnchor>
              <ButtonAnchor href={data.profile_path}>Ir a mi perfil</ButtonAnchor>
            </div>
          </div>
        </Panel>
      </div>
    </div>
  )
}
